import { atom } from "jotai";

import type { AppBarVariant } from "./helpers";

export type State = {
  scrollOverVariant: AppBarVariant | null;
} | null;

export const appBarAtom = atom<State>(null);
